import React, { useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Typography, Button } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import { Context as CartContext } from "../../context/cart.context";
import { Context as AuthContext } from '../../context/auth.context';

import Row from "../Row";

const Header = () => {
  const { state } = useContext(CartContext);
  const auth = useContext(AuthContext);
  let history = useHistory();
  const { opID } = useParams();

  const backRoute = () => {
    console.log(history.location.pathname.split("/")[2]);
    switch (history.location.pathname.split("/")[2]) {
      case "view_record":
        return {
          path: `/${opID}/search_records`,
          text: "to search records",
        };
      default:
        return {
          path: null,
          text: null,
        };
    }
  };

  return (
    <Row style={{ paddingTop: 25, paddingBottom: 25 }}>
      {/* <Typography variant="h5" style={{ margin: 0, paddingLeft: 15 }}>
        Property
      </Typography> */}
      {history.location.pathname.split("/")[2] !== "accept_terms" &&
        history.location.pathname.split("/")[2] !== "search_records" && (
          <Button
            variant="text"
            startIcon={<ArrowBackIosIcon />}
            onClick={() => {
              history.push(backRoute().path);
            }}
          >
            Back {backRoute().text}
          </Button>
        )}
      <input
        className="ipayfield"
        data-ipayname="amount"
        type="hidden"
        value={state.total}
      />
      <input
        className="ipayfield"
        data-ipayname="account"
        type="hidden"
        value={state.accountNumbers.join(", ")}
      />
      {auth.state.merchant.enableCoris == 1 && (
        <>
          <input
            className="ipayfield"
            data-ipayname="firstname"
            type="hidden"
            value={state.owners.join(", ").split(' ')[0]}
          />

          <input
            className="ipayfield"
            data-ipayname="lastname"
            type="hidden"
            value={(state.owners.join(", ").split(' ').length >= 2 ? state.owners.join(", ").substr(state.owners.join(", ").indexOf(' ') + 1) : '')}
          />

        </>
      )} 
      {auth.state.merchant.enableCoris != 1 && (
        <input
          className="ipayfield"
          data-ipayname="lastname"
          type="hidden"
          value={state.owners.join(", ")}
        />
      )} 

      <input
        className="ipayfield"
        data-ipayname="address1"
        type="hidden"
        value={(state.address1.length > 1 ? "Multiple Addresses" : state.address1[0])}
      />
      <input
        className="ipayfield"
        data-ipayname="address2"
        type="hidden"
        value={(state.address2.length > 1 ? "" : state.address2[0])}
      />
      <input
        className="ipayfield"
        data-ipayname="city"
        type="hidden"
        value={(state.city.length > 1 ? "" : state.city[0])}
      />
      <input
        className="ipayfield"
        data-ipayname="state"
        type="hidden"
        value={(state.state.length > 1 ? "" : state.state[0])}
      />
      <input
        className="ipayfield"
        data-ipayname="zipcode"
        type="hidden"
        value={(state.zipcode.length > 1 ? "" : state.zipcode[0])}
      />
      <input
        className="ipayfield"
        data-ipayname="invoices"
        type="hidden"
        value={state.invoices}
      />
      <input
        className="ipayfield"
        data-ipayname="applyInvoicePayment"
        type="hidden"
        value={JSON.stringify(state.applyInvoicePayment)}
      />
    </Row>
  );
};

export default Header;
